import { render, staticRenderFns } from "./ItsCustomsDeclearationResult.vue?vue&type=template&id=315a0b4a&scoped=true&"
import script from "./ItsCustomsDeclearationResult.vue?vue&type=script&lang=js&"
export * from "./ItsCustomsDeclearationResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315a0b4a",
  null
  
)

export default component.exports